import {Component, Input} from '@angular/core';
import {ModalController, ToastController} from '@ionic/angular';
import {DoctorPanelActions} from '@modules/doctor-panel/store/doctor-panel.actions';
import {Store} from '@ngxs/store';
import {EnrolmentStatus} from '../enrolment-requests-list/enrolment-status';

@Component({
  selector: 'app-dialog-enrolment-patient',
  templateUrl: './dialog-enrolment-patient.html',
  styleUrl: './dialog-enrolment-patient.scss',
  standalone: false,
})
export class DialogEnrolmentPatient {

  /**
   * flag che indica se mostrare text area di note per approvazione/rifiuto
   */
  @Input()
  isApprove?: boolean;

  /** 
   * dati del paziente da visualizzare nel dialog
   * */
  @Input()
  patientData: any;

  specialistNotes: string = '';

  constructor(private modalCtrl: ModalController,
    private toastController: ToastController,
    private store: Store
  ) { }

  saveAction(): void {
    this.store
      .dispatch(
        new DoctorPanelActions.ApproveDeniedRequestPatientsToEnrol({
          id: this.patientData.id,
          approval: {status: EnrolmentStatus.REJECTED, note: this.specialistNotes},
        })).subscribe((data: any) => {
          // chiudi dialogo e aggiorna lista richieste in PENDING stato
          if (data) {
            this.successToast();
            this.store.dispatch(new DoctorPanelActions.ListaRequestPatientsToEnrol({structureId: this.patientData.structureId, status: EnrolmentStatus.PENDING}));
            this.modalCtrl.dismiss({pdtaSaved: true});
          }
        },
          (error) => {
            // gestione errore
            this.store.dispatch(new DoctorPanelActions.ApproveDeniedRequestPatientsToEnrolError(error));
          }
        )
  }

  onClose(): void {
    // Close the dialog logic here
    this.modalCtrl.dismiss();
  }

  async successToast() {
    const toast = await this.toastController.create({
      header: "Ok",
      message: "Presa in carico del rifiuto arruolamento paziente avvenuta con successo",
      duration: 3000,
      color: "success",
      position: "bottom",
    });
    toast.present();
    //await this.modalController.dismiss();
  }

  async errorToast(err: any) {
    const toast = await this.toastController.create({
      header: "Errore nella presa in carico del rifiuto arruolamento paziente",
      message: err,
      duration: 3000,
      color: "danger",
      position: "bottom",
    });
    toast.present();
    //await this.modalController.dismiss();
  }
}
